<div
  style="position: absolute; height: 100%; width: 100%; z-index: 1000"
  *ngIf="loadingStatus.isLoading"
>
  <div style="display: flex; flex-direction: row; width: 100%; height: 100%">
    <div style="flex-grow: 1"></div>
    <div style="flex-grow: 1"></div>
    <div style="display: flex; flex-direction: column; flex-grow: 1">
      <div style="flex-grow: 1"></div>
      <div style="flex-grow: 1"></div>
      <div
        style="
          flex-grow: 1;
          text-align: center;
          background-color: #ddd;
          color: black;
          border-style: solid;
          border-color: black;
        "
      >
        <span style="vertical-align: middle; font-size: 24px; font-weight: 900">
          <br /><br /><br /><br /><br />
          {{ loadingStatus.loadingMessage }}
        </span>
        ... <i class="fas fa-spinner fa-pulse"></i>
      </div>
      <div style="flex-grow: 1"></div>
      <div style="flex-grow: 1"></div>
    </div>
    <div style="flex-grow: 1"></div>
    <div style="flex-grow: 1"></div>
  </div>
</div>
<header class="site-header" *ngIf="!isFullScreenMode">
  <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow">
    <h5 class="my-0 mr-md-auto font-weight-normal">
      <a id="appIcon" [routerLink]="['/']" title="Public Insight">
        <img src="../assets/Public-Insight-logo-primary.png" style="height: 1.4em" />
      </a>
    </h5>
    <app-nav-menu></app-nav-menu>
  </div>
</header>
<main role="main" class="site-body" *ngIf="!isFullScreenMode">
  <ng-container *ngIf="showAlertMessages">
    <div *ngFor="let msg of alertMessages" style="width: 100%; background-color: #f7910d; color: #232a3a;">
      <center>
        <b>ALERT: </b>{{msg.message}}&nbsp;&nbsp;&nbsp;&nbsp;<a href="#" style="color: #232a3a; " (click)="showAlertMessages = false;">Dismiss</a>
      </center>
    </div>
  </ng-container>
  <ng-container *ngIf="showExpiredSubscriptions">
    <div *ngFor="let msg of expiredSubscriptions" style="width: 100%; background-color: #f7910d; color: #232a3a">
      <center>
        <b>Expired Subscription: </b>{{msg.message}}&nbsp;&nbsp;&nbsp;&nbsp;<a href="#" style="color: #232a3a; " (click)="showExpiredSubscriptions = false;">Dismiss</a>
      </center>
    </div>
  </ng-container>
  <router-outlet></router-outlet>
</main>
<footer class="site-footer border-top box-shadow" *ngIf="!isFullScreenMode">
  <div style="text-align: center">
    <span class="text-muted">
      &copy; {{ currentYear }} Public Insight Data Corporation. All rights
      reserved. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
        [href]="ppUrl"
        rel="nofollow"
        target="_blank"
        >Privacy Policy</a
      >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
        [href]="tosUrl"
        rel="nofollow"
        target="_blank"
        >Terms and Conditions</a
      >
    </span>
  </div>
</footer>
<div *ngIf="isFullScreenMode">
  <router-outlet></router-outlet>
</div>
